import request from '@/utils/request'

/**
 * 添加供应商批次信息(qiuyanping)(wzp)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function supplierBatchAdd(data) {
  return request({
    type: 'biz',
    url: 'supplier/batch/add',
    method: 'post',
    data
  })
}
/**
 * 删除供应商批次信息(cme)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function supplierBatchDelete(data) {
  return request({
    type: 'biz',
    url: 'supplier/batch/delete',
    method: 'post',
    data
  })
}
/**
 * 获取供应商批次图片信息（凭证照片）(cme)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function supplierBatchFileGet(data) {
  return request({
    type: 'biz',
    url: 'supplier/batch/file/get',
    method: 'post',
    data
  })
}
/**
 * 获取供应商批次号列表信息(Liurl)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function supplierBatchNumberListGet(data) {
  return request({
    type: 'biz',
    url: 'supplier/batch/number/list/get',
    method: 'post',
    data
  })
}
/**
 * 获取供应商批次列表(cme)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function supplierBatchPageListGet(data) {
  return request({
    type: 'biz',
    url: 'supplier/batch/page/list/get',
    method: 'post',
    data
  })
}
/**
 * 更新供应商批次信息(qiuyanping)(wzp)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function supplierBatchUpdate(data) {
  return request({
    type: 'biz',
    url: 'supplier/batch/update',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/SupplierBatch.js